import React from "react";
import { Container } from "react-bootstrap";
import styles from "./index.module.css";

const ApplyNow = (props) => {
  return (
    <Container fluid className={styles.section}>
      <div className={styles.button_div}>{props.btnTitle}</div>
    </Container>
  );
};

export default ApplyNow;
